import { DataResponse } from '@/common/Response';
import { IUserLoginResponse } from '@/data/auth/types';
import { ILoginVariables, INewPasswordVariables } from '@/domain/auth/entities';
import { IChangePassVariables } from '@/domain/user/entities';
import { RefreshToken } from '@/models/auth/RefreshToken';
import { IResetPassword } from '@/models/auth/ResetPassword';
import { ValidateForgotKey } from '@/models/auth/ValidateForgotKey';
import { Api, ApiOptions } from '@/utils/api';

const authService = {
  authenticate: (token: string) => {
    return Api.post<DataResponse<IUserLoginResponse>>('/api/v1/auth', {
      token: token,
    });
  },
  login: (bodyLogin: ILoginVariables, options?: ApiOptions) => {
    return Api.post<DataResponse<IUserLoginResponse>>(
      '/api/v1/auth/login',
      { ...bodyLogin },
      options,
    );
  },
  refreshToken: (accessToken: string, refreshToken: string) => {
    return Api.post<DataResponse<RefreshToken>>(
      '/api/auths/token/refresh',
      { accessToken, refreshToken },
      {
        replaceHeaders: {
          'Content-Type': 'application/json',
        },
      },
    );
  },
  createSocketToken: () => {
    return Api.post<DataResponse<string>>('/api/auths/token/socket');
  },
  updatePassword: (params: IChangePassVariables, options?: ApiOptions) => {
    return Api.patch<DataResponse<boolean>>(
      '/api/v1/me/password',
      params,
      options,
    );
  },
  forgotPassword: (email: string, options?: ApiOptions) => {
    return Api.post<DataResponse<string>>(
      '/api/v1/auth/forgot-password',
      { email },
      options,
    );
  },
  validateForgotKey: (params: ValidateForgotKey, options?: ApiOptions) => {
    return Api.post<DataResponse<boolean>>(
      '/api/auths/validate-forgot-key',
      params,
      options,
    );
  },
  resetPassword: (
    params: IResetPassword | INewPasswordVariables,
    options?: ApiOptions,
  ) => {
    return Api.post<DataResponse<boolean>>(
      '/api/v1/auth/reset-password',
      params,
      options,
    );
  },
};

export default authService;
